"use client";
import React, { Fragment } from "react";

export default function Diagram({ items = [] }) {
  return (
    <div className="container flex flex-col items-center max-w-lg mx-auto">
      {items?.[0]?.map((item, ind) => {
        const isFirst = ind === 0;
        const isLast = ind === items[0].length - 1;

        return (
        <Fragment key={item?.['as_number'] + ind}>
          {/* Arrow connector */}
          {ind !== 0 && (
            <div className="relative h-10 w-full flex justify-center">
              <div className="absolute w-[1px] h-full bg-surface3 dark:bg-dark-br-low" />
              <div className="absolute bottom-0 left-1/2 -translate-x-1/2">
                <svg 
                  width="16" 
                  height="8" 
                  viewBox="0 0 16 8" 
                  fill="none" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path 
                    d="M7.29289 7.70711C7.68342 8.09763 8.31658 8.09763 8.70711 7.70711L15.0711 1.34315C15.4616 0.952623 15.4616 0.319465 15.0711 -0.0710678C14.6805 -0.461601 14.0474 -0.461601 13.6569 -0.0710678L8 5.58579L2.34315 -0.0710678C1.95262 -0.461601 1.31946 -0.461601 0.928932 -0.0710678C0.538408 0.319465 0.538408 0.952623 0.928932 1.34315L7.29289 7.70711ZM7 6L7 7L9 7L9 6L7 6Z"
                    className="fill-surface3 dark:fill-dark-br-low" 
                  />
                </svg>
              </div>
            </div>
          )}
          
          <div className="group relative w-full flex justify-center animate-slideUp"
               style={{ animationDelay: `${ind * 150}ms` }}>
            <div className={`relative cursor-pointer transition-all duration-300 w-48 py-3
                          bg-surface2 dark:bg-dark-surface2
                          border-2 border-surface3 dark:border-dark-surface3 
                          shadow-md hover:shadow-lg
                          ${isFirst ? 'rounded-t-3xl rounded-b-lg' : 
                            isLast ? 'rounded-t-lg rounded-b-3xl' : 
                            'rounded-lg'}`}>
              {/* Content */}
     <a href={item?.link} target="_blank" rel="noopener noreferrer">
     <div className="flex flex-col items-center gap-1.5">
                <span className="text-xs font-semibold text-primary dark:text-primary-fixed">
                  {item?.asn}
                </span>
                <span className="text-sm font-bold text-neutral-default dark:text-dark-neutral-default">
                  {item?.['as_number']}
                </span>
              </div>
              </a>

              {/* Enhanced gradient background */}
              <div className={`absolute inset-0 bg-gradient-to-b from-surface1/70 to-transparent 
                             dark:from-dark-surface1/50 dark:to-transparent pointer-events-none
                             ${isFirst ? 'rounded-t-3xl rounded-b-lg' : 
                               isLast ? 'rounded-t-lg rounded-b-3xl' : 
                               'rounded-lg'}`} />
            </div>
            
            {/* Tooltip */}
            <div className="invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-all duration-200 absolute -top-12 z-50">
              <div className="px-3 py-2 rounded-md 
                            bg-dark-surface1/90 dark:bg-dark-surface2/90 
                            text-dark-neutral-default dark:text-dark-neutral-default 
                            text-xs shadow-lg backdrop-blur-sm">
                {item?.['as_name']}
                <div className="absolute -bottom-1 left-1/2 -translate-x-1/2">
                  <div className="w-2 h-2 
                                bg-dark-surface1/90 dark:bg-dark-surface2/90 
                                rotate-45" />
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      )})}
    </div>
  );
}
